// Partitions risks into visible/suppressed using risks_v2.filter_status.
//
// Guardrails are applied by an LLM, never by keyword matching: the
// issue-filter-assistant edge function re-judges every open risk when the
// policy changes, and process-transcript-v2 judges new risks at creation time.
// Both stamp their verdict onto risks_v2.filter_status, so the client only
// needs to read that column. Rows must therefore be selected with
// `filter_status` (and ideally `filter_decision_reason`).

export function applyIssuePolicy(risks, _policy) {
  if (!Array.isArray(risks)) return { visible: [], suppressed: [] };

  const visible = [];
  const suppressed = [];
  for (const r of risks) {
    if (r.filter_status === 'suppressed') {
      suppressed.push({ ...r, _suppressedBy: { reason: r.filter_decision_reason || 'Hidden by issue guardrails' } });
    } else {
      visible.push(r);
    }
  }
  return { visible, suppressed };
}

export function defaultPolicy() {
  return {
    summary: 'Default TutorTracer filtering: show all flagged issues.',
    instructions: '',
    suppressions: [],
    version: 1,
  };
}
